import { useEffect } from 'react';
import { MenuCategories } from 'common/propTypes/builtMenuTypes';
import { useQueryParameters } from 'common/hooks';
import { scrollToElement } from 'menus/providers/MenuScrollListenerProvider/scrolling-utils';

export const useMenuScrollFromParams = (categories: MenuCategories) => {
  const [urlCategory, urlSubCategory] = useQueryParameters();

  const categoryTab = categories.find(({ category }) => category === urlCategory);

  useEffect(() => {
    if (urlCategory && categoryTab) scrollToElement(categoryTab.ref, 'auto')();
  }, [urlCategory, categoryTab]);

  useEffect(() => {
    const subCategoryTab = categoryTab?.subCategories?.find(({ name }) => name === urlSubCategory);
    if (urlSubCategory && subCategoryTab) scrollToElement(subCategoryTab.ref, 'auto')();
  }, [urlSubCategory, categoryTab]);
};
